import { css } from 'styled-components';
import { colorTokens } from '../../tokens/globals/tokens';

// Absolute full size
//
// Creates an element that takes the full size
// of its closest "position: relative" parent.
// The gap parameter is used to create a constant
// displacement between the element and its wrapper.
const absoluteFullSize = (gap = 0) => {
  return css`
    bottom: ${gap}px;
    left: ${gap}px;
    position: absolute;
    right: ${gap}px;
    top: ${gap}px;
  `;
};

const bottomRightTriangle = (size = 10, color = colorTokens.GlobalBrandGray30) => {
  return css`
    border-color: transparent transparent ${color} transparent;
    border-style: solid;
    border-width: 0 0 ${size}px ${size}px;
    bottom: 0;
    height: 0;
    position: absolute;
    right: 0;
    transition-duration: 100ms;
    transition-property: border-color, border-width;
    transition-timing-function: ease-in-out;
    width: 0;
    will-change: border;
  `;
};

export default { absoluteFullSize, bottomRightTriangle };
